import axios from "axios";

// Set at build time. Empty = same origin.
const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

const getSessionId = () => localStorage.getItem("session_id");

const authHeaders = () => ({
  "X-Session-ID": getSessionId(),
});

export const getMeals = async () => {
  const response = await axios.get(`${API_URL}/meals`, { headers: authHeaders() });
  return response.data;
};

export const addMeal = async (meal) => {
  const response = await axios.post(`${API_URL}/meals`, meal, { headers: authHeaders() });
  return response.data;
};

export const deleteMeal = async (id) => {
  const response = await axios.delete(`${API_URL}/meals/${id}`, { headers: authHeaders() });
  return response.data;
};

export const updateMeal = async (id, meal) => {
  const response = await axios.put(`${API_URL}/meals/${id}`, meal, { headers: authHeaders() });
  return response.data;
};

export const clearMeals = async () => {
  const response = await axios.delete(`${API_URL}/meals`, { headers: authHeaders() });
  return response.data;
};

export const sendChat = async (message) => {
  const response = await axios.post(
    `${API_URL}/chat`,
    { message },
    { headers: authHeaders() }
  );
  return response.data;
};
